import { render, staticRenderFns } from "./CmpXTree.vue?vue&type=template&id=2779c884&scoped=true&"
import script from "./CmpXTree.vue?vue&type=script&lang=js&"
export * from "./CmpXTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2779c884",
  null
  
)

export default component.exports